import React from 'react';

import List from './List';

import { BackofficeBriefings } from './style/BackofficeBriefings';
import { ContentTitle } from '../../utilities/styledComponents/ContentTitle';

const Home = (props) => {
	const { history } = props;

	if (history) {
		window.scrollTo(0, 0);
	}

	return (
		<BackofficeBriefings>
			<div className="page-container ">
				<article className="position-relative" id="home-page">
					<div className="content-welcome p-0">
						<ContentTitle>Listagem de demandas</ContentTitle>

						<List history={history} />
					</div>
				</article>
			</div>
		</BackofficeBriefings>
	);
};

export default Home;
